export { default as VerticalLayout } from './Vertical';
export { default as DefaultLayout } from './Default';
export { default as DetachedLayout } from './Detached';
export { default as HorizontalLayout } from './Horizontal';
export { default as FullLayout } from './Full';
